export default __webpack_public_path__ + "static/media/patientdivimage.2bb81257.PNG";